import { LightningElement, api, wire } from "lwc";
import "@devforce/trailhead-client-logger";
import { LabelsAdapter } from "common/labelsAdapter";
import { I18n } from "@devforce/trailhead-client-locale";
import { c as classNames } from "tds/chunk_index";
import { htmlToText, attrToBool } from "common/helpers";
import { assignedSlotNames } from "common/slot";
import { ResizeObserverAdapter } from "common/resizeObserverAdapter";
import { createTrack } from "common/track";

var data$9 = {
  learningDynamicCta: "Mit dem Lernen beginnen",
  groupDynamicCta: "Jetzt teilnehmen",
  topicDynamicCta: "Thema folgen",
  jobDynamicCta: "Bewerben",
  lastUpdated: "Zuletzt aktualisiert am: %{date}",
};
data$9.learningDynamicCta;
data$9.groupDynamicCta;
data$9.topicDynamicCta;
data$9.jobDynamicCta;
data$9.lastUpdated;

var data$8 = {
  learningDynamicCta: "Start learning",
  groupDynamicCta: "Join us now",
  topicDynamicCta: "Follow topic",
  jobDynamicCta: "Apply",
  lastUpdated: "Last Updated On: %{date}",
};
data$8.learningDynamicCta;
data$8.groupDynamicCta;
data$8.topicDynamicCta;
data$8.jobDynamicCta;
data$8.lastUpdated;

var data$7 = {
  learningDynamicCta: "Empezar a aprender",
  groupDynamicCta: "Únase ahora",
  topicDynamicCta: "Seguir tema",
  jobDynamicCta: "Solicitar",
  lastUpdated: "Última actualización: %{date}",
};
data$7.learningDynamicCta;
data$7.groupDynamicCta;
data$7.topicDynamicCta;
data$7.jobDynamicCta;
data$7.lastUpdated;

var data$6 = {
  learningDynamicCta: "Empezar a aprender",
  groupDynamicCta: "Unirse ahora",
  topicDynamicCta: "Seguir tema",
  jobDynamicCta: "Aplicar",
  lastUpdated: "Última actualización el: %{date}",
};
data$6.learningDynamicCta;
data$6.groupDynamicCta;
data$6.topicDynamicCta;
data$6.jobDynamicCta;
data$6.lastUpdated;

var data$5 = {
  learningDynamicCta: "Commencez l’apprentissage",
  groupDynamicCta: "Rejoignez-nous sans attendre",
  topicDynamicCta: "Suivre la rubrique",
  jobDynamicCta: "Postuler",
  lastUpdated: "Date de dernière mise à jour : %{date}",
};
data$5.learningDynamicCta;
data$5.groupDynamicCta;
data$5.topicDynamicCta;
data$5.jobDynamicCta;
data$5.lastUpdated;

var data$4 = {
  learningDynamicCta: "Inizia a imparare",
  groupDynamicCta: "Iscriviti subito",
  topicDynamicCta: "Segui l'argomento",
  jobDynamicCta: "Candidati",
  lastUpdated: "Ultimo aggiornamento: %{date}",
};
data$4.learningDynamicCta;
data$4.groupDynamicCta;
data$4.topicDynamicCta;
data$4.jobDynamicCta;
data$4.lastUpdated;

var data$3 = {
  learningDynamicCta: "学習を始める",
  groupDynamicCta: "今すぐ参加しよう",
  topicDynamicCta: "トピックをフォロー",
  jobDynamicCta: "応募",
  lastUpdated: "最終更新日: %{date}",
};
data$3.learningDynamicCta;
data$3.groupDynamicCta;
data$3.topicDynamicCta;
data$3.jobDynamicCta;
data$3.lastUpdated;

var data$2 = {
  learningDynamicCta: "학습 시작",
  groupDynamicCta: "지금 가입",
  topicDynamicCta: "주제 팔로우",
  jobDynamicCta: "지원하기",
  lastUpdated: "최근 업데이트: %{date}",
};
data$2.learningDynamicCta;
data$2.groupDynamicCta;
data$2.topicDynamicCta;
data$2.jobDynamicCta;
data$2.lastUpdated;

var data$1 = {
  learningDynamicCta: "Comece a aprender",
  groupDynamicCta: "Junte-se a nós agora",
  topicDynamicCta: "Seguir tópico",
  jobDynamicCta: "Candidatar-se",
  lastUpdated: "Última atualização em: %{date}",
};
data$1.learningDynamicCta;
data$1.groupDynamicCta;
data$1.topicDynamicCta;
data$1.jobDynamicCta;
data$1.lastUpdated;

var data = {
  learningDynamicCta: "开始学习",
  groupDynamicCta: "立即加入我们",
  topicDynamicCta: "关注主题",
  jobDynamicCta: "申请职位",
  lastUpdated: "最后更新于: %{date}",
};
data.learningDynamicCta;
data.groupDynamicCta;
data.topicDynamicCta;
data.jobDynamicCta;
data.lastUpdated;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

const i18n = new I18n({
  summary: locales,
});
class summary extends LightningElement {
  @api description = null;
  @api descriptionTruncateType = null;
  @api descriptionTruncateDisplayMode = null;
  @api descriptionTruncateLabel = null;
  @api descriptionHtml = null;
  @api details = null;
  @api path = null;
  @api pathTarget = null;
  @api hideNewWindowIcon;
  @api pretitle = null;
  @api pretitleLinkHref = null;
  @api pretitleLinkTarget = null;
  @api pretitleLinkTitle = null;
  @api pretitleTruncateLines = 1;
  @api pretitleHtml = null;
  @api title = "";
  @api htmlConfig = null;
  @api titleHeadingLevel = null;
  @api titleTruncateLines = 2;
  @api type = "";
  @api descriptionTruncateLines = 2;
  @api variant = "brick";
  @api metaLeftTruncateLines = 1;
  @api metaRightTruncateLines = 1;
  @api dynamicCta;
  @api dynamicCtaIcon;
  @api dynamicCtaIconSymbol = null;
  @api updatedAt = null;
  @api get titleMode() {
    // Backwards compatability
    if (this._titleMode === "anchor" && !this.path) {
      return "button";
    }
    return this._titleMode;
  }
  set titleMode(value) {
    this._titleMode = value;
  }
  _titleMode = "anchor";
  size = "default";
  slots = new Set();
  slotNames = "";
  width = Number.MAX_SAFE_INTEGER;
  track = createTrack(this);
  get contentAlignment() {
    return this.isCompact ? "center" : "start";
  }
  get computedVariant() {
    switch (this.variant) {
      case "brick-tile":
        return this.width < 350 ? "tile" : "brick";
      case "tile-brick":
        return this.width > 500 ? "brick" : "tile";
      default:
        return this.variant;
    }
  }
  get isCompact() {
    return (
      !this.description &&
      !this.descriptionHtml &&
      !this.slots.has("meta-left") &&
      !this.slots.has("meta-right")
    );
  }
  get isTile() {
    return this.computedVariant === "tile";
  }
  get assistivePretitle() {
    if (this.pretitleHtml) {
      // check if a pretitle plain text is provided alongside pretitleHTML, if so use it as assistive text, if not generate.
      return this.pretitle || htmlToText(this.pretitleHtml);
    }
    return this.pretitle;
  }
  get showPretitle() {
    return (
      typeof this.pretitle === "string" ||
      typeof this.pretitleLinkTitle === "string" ||
      typeof this.pretitleHtml === "string" ||
      this.slots.has("pretitle")
    );
  }
  get titleIsAnchor() {
    return this.titleMode === "anchor";
  }
  get titleIsButton() {
    return this.titleMode === "button";
  }
  get titleIsText() {
    return this.titleMode === "text";
  }
  get titleIsHTML() {
    return this.titleMode === "html";
  }
  get titleTruncateLineSize() {
    return 18 * 1.3; // font-size * line-height
  }
  get metaTruncateLineSize() {
    return 14 * 1.4; // font-size * line-height
  }
  get showDescription() {
    return this.description || this.descriptionHtml;
  }
  get showDetails() {
    return this.details?.length;
  }
  get showUpdatedAt() {
    return this.updatedAt;
  }
  get descriptionClassName() {
    return classNames("content__description", {
      "content__description--html": !!this.descriptionHtml,
    });
  }
  get displayDynamicCta() {
    return attrToBool(this.dynamicCta);
  }
  get displayDynamicCtaIcon() {
    return attrToBool(this.dynamicCtaIcon);
  }
  get displayNewWindowIcon() {
    return !attrToBool(this.hideNewWindowIcon) && this.pathTarget === "_blank";
  }
  get dynamicCtaText() {
    switch (this.type) {
      case "module":
      case "project":
      case "trail":
      case "superbadge":
      case "trailmix":
      case "learningpath":
        return this.labels.learningDynamicCta;
      case "group":
        return this.labels.groupDynamicCta;
      case "topic":
        return this.labels.topicDynamicCta;
      case "job":
        return this.labels.jobDynamicCta;
      default:
        throw new Error(`Unsupported type for dynamic cta: "${this.type}"`);
    }
  }
  get dynamicCtaAriaLabel() {
    return `${this.dynamicCtaText}: ${this.title}`;
  }
  get updatedAtLabel() {
    return i18n.t("summary", "lastUpdated", {
      date: `${this.updatedAt}`,
    });
  }
  @wire(ResizeObserverAdapter, {
    template: "$template",
  })
  onResize(entry) {
    const breakpoint = this.variant === "tile" ? 280 : 400;
    this.size = entry.contentRect.width < breakpoint ? "small" : "default";
    this.width = entry.contentRect.width;
    this.dispatchEvent(
      new CustomEvent("resize", {
        detail: {
          entry,
          size: this.size,
        },
      })
    );
  }
  onSlotChange() {
    let slots = assignedSlotNames(this.template);
    this.slots = new Set(slots);
    this.slotNames = slots.join(" ");
  }
  onTitleClick() {
    this.dispatchEvent(new CustomEvent("navigate"));
  }
  onCtaClick() {
    this.dispatchEvent(
      new CustomEvent("dynamicctaclick", {
        detail: {
          ctaLabel: this.dynamicCtaText,
        },
      })
    );
  }
  handleDescriptionTruncateTrack(e) {
    this.track("truncate_link_clicked", e.detail.payload);
  }
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;
}

export default summary;
